export default __webpack_public_path__ + "static/diamant-55e0e19ba04b9fa444df8a0321493ecf.jpg";